import sdl from '@jds/react-generated-sdl/SwadeshDisplayCard';
import type { SwadeshDisplayCardProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic } from '../logic';

const Component = (props: SwadeshDisplayCardProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const {
    size = '3_4',
    showClose = false,
    showArrows = false,
    custom = '',
    ...rest
  } = props as any;
  return createComponent(
    json,
    { size, showClose, showArrows, ...rest },
    'SwadeshDisplayCard',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const SwadeshDisplayCard = withLogic(
  Component
) as React.FC<SwadeshDisplayCardProps> & { slotName?: string };

SwadeshDisplayCard.displayName = 'SwadeshDisplayCard';
SwadeshDisplayCard.slotName = 'swadesh_display_card';

export { SwadeshDisplayCard, type SwadeshDisplayCardProps };
